import { graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import React from "react"
import { IStaticImageProps } from "../gridLayout1/OneLargeTwoSmall"
import ProductFooter from "../footer/ProductFooter"

const SmallStaticImage2: React.FC<IStaticImageProps> = ({
  backgroundImage,
  footer,
}) => {
  const gatsbyImage = backgroundImage && getImage(backgroundImage.gatsbyImage)

  return (
    <div className="relative flex min-h-[249px] flex-col justify-end bg-cover bg-bottom bg-no-repeat text-white">
      <div className="absolute top-0 left-0 h-full w-full">
        {gatsbyImage && (
          <GatsbyImage
            image={gatsbyImage}
            alt={backgroundImage.altText}
            className="absolute top-0 left-0 h-full w-full rounded object-cover object-bottom"
          />
        )}
        <div className="absolute left-0 top-0 h-full w-full rounded bg-[linear-gradient(270deg,#000000_0%,#00000000_72.98%)]" />
        <div className="absolute left-0 top-0 h-full w-full rounded bg-darkBlue bg-opacity-40" />
      </div>
      {footer?.headline && <ProductFooter {...footer} />}
    </div>
  )
}

export default SmallStaticImage2

export const fragment = graphql`
  fragment SmallStaticImage2 on WpDefaultTemplate_Acf_Modules_Promos_Promos_GridLayout1 {
    fieldGroupName
    smallTile2Smallblocks {
      ... on WpDefaultTemplate_Acf_Modules_Promos_Promos_GridLayout1_SmallTile2Smallblocks_StaticImage {
        fieldGroupName
        backgroundImage {
          altText
          gatsbyImage(
            quality: 85
            layout: FULL_WIDTH
            width: 500
            height: 250
            formats: [AUTO, WEBP]
          )
        }
        footer {
          headline
          link {
            target
            title
            url
          }
        }
      }
    }
  }
`
